import { render, staticRenderFns } from "./SumberDana.vue?vue&type=template&id=98f2243e"
import script from "./SumberDana.vue?vue&type=script&lang=js"
export * from "./SumberDana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports